var React = require('react');

function CircleIconArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M33.5 2C50.897 2 65 16.103 65 33.5S50.897 65 33.5 65 2 50.897 2 33.5 16.103 2 33.5 2z","className":"circle","key":0}),React.createElement("g",{"strokeLinecap":"round","className":"icon","key":1},React.createElement("path",{"d":"M20.253 33.545h27.119M47.452 33.545L35.32 21.54M47.452 33.545L35.32 45.55"}))]);
}

CircleIconArrowInline.defaultProps = {"viewBox":"0 0 68 68","strokeWidth":"2"};

module.exports = CircleIconArrowInline;

CircleIconArrowInline.default = CircleIconArrowInline;
